module.exports = __webpack_public_path__ + "img/aviation_system_m.2e9f61b9.png";